Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.FooterView extends Backbone.View

  template: JST["backbone/templates/monitoring/reports/executive/footer"]
  id: 'monitoring-report-footer'
  className: 'row-fluid'

  initialize: (@options) ->
    if @options.settings.footer
      @text = @options.settings.footer.footer_text

  render: ->
    if @text or @img
      @$el.html(@template(text: @text, img: @img))
